
import React from 'react';
import Layout from '@/components/Layout/Layout';
import VolumeConverter from '@/components/UnitConverter/VolumeConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const VolumeConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Volume Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between different units of volume, from milliliters to gallons and more.
          </p>
        </div>
        
        <div className="mb-8">
          <VolumeConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Volume Converter</h2>
          <p>
            Our volume converter tool allows you to quickly and accurately convert between different 
            units of volume and capacity. This is especially useful for cooking, chemistry, or any 
            field where liquid or space measurements are needed.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Volume Unit Conversions</h3>
          <p>
            Some of the most frequently used volume conversions include:
          </p>
          <ul className="list-disc ml-6">
            <li>Converting between liters and gallons</li>
            <li>Converting milliliters to fluid ounces</li>
            <li>Converting cups to milliliters (useful in cooking)</li>
            <li>Converting between metric and US customary units</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use the Volume Converter</h3>
          <p>
            Using our volume converter is simple:
          </p>
          <ol className="list-decimal ml-6">
            <li>Enter the value you want to convert in the "From" field</li>
            <li>Select the unit you're converting from in the dropdown</li>
            <li>Select the unit you want to convert to in the "To" dropdown</li>
            <li>The converted value will appear automatically</li>
          </ol>
          
          <p className="mt-6">
            The volume converter supports a comprehensive range of units, including milliliters, 
            liters, cubic meters, fluid ounces, cups, pints, quarts, gallons, and more. Whether you're 
            following a recipe from another country or calculating fluid volumes for scientific purposes, 
            our converter provides accurate results instantly.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default VolumeConverterPage;
